export enum CardSize {
  /** a quarter of a `small` cell - metrics only */
  extraSmall = 'extraSmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum CardType {
  Chart = 'chart',
  Metric = 'metric',
}

/** how a metric card renders its value - stashed inside additionalConfig, defaults to Numeric for legacy cards */
export enum MetricDisplayType {
  Numeric = 'numeric',
  Gauge = 'gauge',
}

export enum MetricSplitSubsetMode {
  Highest = 'highest',
  Lowest = 'lowest',
  ClosestToTarget = 'closestToTarget',
  FurthestFromTarget = 'furthestFromTarget',
  HighestUnderTarget = 'highestUnderTarget',
  LowestOverTarget = 'lowestOverTarget',
}

/** determines whether a metric meets its target by being at least or at most the target value */
export enum TargetComparison {
  AtLeast = 'atLeast',
  AtMost = 'atMost',
}

/** position of an `extraSmall` metric within its shared `small` cell */
export enum Quadrant {
  TopLeft = 0,
  TopRight = 1,
  BottomLeft = 2,
  BottomRight = 3,
}

export enum ChartDataSource {
  Tasks = 0,
  Claims = 1,
  Jobs = 2,
  TaskDurations = 3,
  Cashflow = 4,
  ForecastedTasks = 5,
  ForecastedTasksInProgress = 6,
  Extras = 7,
  JobsBetweenTasks = 8,
}

export enum ChartType {
  Line = 1,
  'Stacked Bar' = 0,
  'Side By Side Bar' = 2,
  'Percentage Bar' = 3,
}

export enum DateAxisType {
  Weekly = 0,
  Monthly = 1,
  Yearly = 2,
  Daily = 3,
}

// only used when a custom value field is defined
export enum ValueAggregationType {
  // 'Count' of items (rather than using a number field) = effect when DEFAULT_VALUE_FIELD is selected as value field
  Sum = 0,
  Average = 1,
  Cumulative = 2,
  'Average - Rolling 3 Period' = 3,
  'Average - Rolling 6 Period' = 4,
}
export const MAX_ROLLING_PERIODS = 6

export enum DateRangeType {
  'Custom' = 0,
  'All Time' = 1,

  'Last 2 Weeks' = 13,
  'Last 4 Weeks' = 14,
  'Last 8 Weeks' = 15,
  'Last 12 Weeks' = 16,
  'Last Month' = 2,
  'Last 3 Months' = 3,
  'Last 6 Months' = 4,
  'Last 12 Months' = 5,
  'Last Year' = 6,
  'Last 5 Years' = 7,

  'Next 2 Weeks' = 17,
  'Next 4 Weeks' = 18,
  'Next 8 Weeks' = 19,
  'Next 12 Weeks' = 20,
  'Next Month' = 8,
  'Next 3 Months' = 9,
  'Next 6 Months' = 10,
  'Next Year' = 11,
  'Next 5 Years' = 12,
}

export enum TaskDurationAggregation {
  Day = 0,
  BusinessDay = 1,
  Week = 2,
}
